import React, { useState, useEffect, useMemo } from 'react';
import Header from '../../layouts/Header';
import { Badge, Button, Col, Dropdown, DropdownButton, Form, FormLabel, InputGroup, Row, Spinner, Table } from 'react-bootstrap';
import { ArrowLeft, Download, FileEarmarkSpreadsheet, Printer, Search } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useNavigate } from 'react-router-dom';
import OutletSelect from '../../components/OutletSelect';
import { MAX_DATE_RANGE_DAYS, DATE_RANGE_ERROR_MESSAGE } from '../../constants/dateConstants';

const AddonSalesReport = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const animatedComponents = makeAnimated();
    const navigate = useNavigate();

    const accessToken = localStorage.getItem("authToken");
    const [outlets, setOutlets] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedCategoryName, setSelectedCategoryName] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [error, setError] = useState('');
    const [clicked, setClicked] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [productList, setProductList] = useState([]);
    const [addonGroup, setAddonGroup] = useState('');
    const [addons, setAddons] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [selectedAddonValue, setSelectedAddonValue] = useState('');
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

    // ── Sorting state ──────────────────────────────────────────────────────────
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    // Derived sorted data — never mutates filteredData
    const sortedData = useMemo(() => {
        if (!sortConfig.key) return filteredData;
        return [...filteredData].sort((a, b) => {
            const aVal = a[sortConfig.key] ?? 0;
            const bVal = b[sortConfig.key] ?? 0;
            const cmp = typeof aVal === 'string'
                ? aVal.localeCompare(bVal)
                : aVal - bVal;
            return sortConfig.direction === 'asc' ? cmp : -cmp;
        });
    }, [filteredData, sortConfig]);

    const handleSort = (key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    // Small icon component — shows ⇅ when inactive, ↑/↓ when active
    const SortIcon = ({ column }) => {
        if (sortConfig.key !== column) {
            return <span style={{ opacity: 0.3, marginLeft: '4px', fontSize: '11px' }}>⇅</span>;
        }
        return (
            <span style={{ marginLeft: '4px', fontSize: '11px', color: '#0d6efd' }}>
                {sortConfig.direction === 'asc' ? '↑' : '↓'}
            </span>
        );
    };
    // ──────────────────────────────────────────────────────────────────────────

    const getAddons = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get("addons?page=1&limit=1000", { headers });
            console.log("Addons Groupns :", response?.data?.data?.addons);

            setAddons(response?.data?.data?.addons);
        } catch (error) {
            console.log("error :", error);
        }
    }

    const getCategoryList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoryList(response?.data?.data?.categories || []);
            }
        } catch (error) {
            handleApiError(error);
        }
    };

    const handleDownloadExcel = async (costing) => {
        setDownloadBtnLoading(true);
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        getAddonsData(adjustedStartDate, adjustedEndDate, selectedOutlet.value, selectedCategory, addonGroup, selectedAddonValue, true, costing);
    };

    const getAddonsData = async (start, end, outlet, category, addonG, addonV, download, costing) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }

            const updatedStartDate = start ? start.toISOString().split("T")[0] : null;
            const updatedEndDate = end ? end.toISOString().split("T")[0] : null;

            let api = `addons/addon-sales-report-for-outlet?startDate=${updatedStartDate}&endDate=${updatedEndDate}&outlet=${outlet}&category=${category}`
            if (addonG) {
                let addonId = addonG?.value;
                console.log("addonId :", addonId);
                api += `&addonId=${addonId}`
            }
            if (addonV) {
                let addValue = addonV.value;
                api += `&addonValueId=${addValue}`
            }

            if (download) {
                api += `&isDownload=${download}`
            }

            if (costing) {
                api += `&isCosting=${costing}`
            }

            const response = await axios.get(api,
                {
                    headers,
                    responseType: download ? 'blob' : 'json'
                }
            );
            console.log("Reponse of report :", response);

            if (download) {
                // Create a blob from the response data
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                // Create a link element
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);

                // Set the filename for the download
                const fileName = `${selectedOutletName} Addon Sales Report For ${selectedCategoryName} (${updatedStartDate} - ${updatedEndDate}).xlsx`;
                link.download = fileName;

                // Append the link to the body and trigger the download
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);

                toast.success('Excel file downloaded successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light"
                });
            } else {
                setFilteredData(response?.data?.data);
                setProductList(response?.data?.data);
                toast.success("Data Fetched Successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }

        } catch (error) {
            console.log("Errorrrrrr in Fetching Report:", error);
            setFilteredData([]);
            setProductList([]);
            handleApiError(error);
        } finally {
            setDownloadBtnLoading(false);
        }
    }

    const handleApiError = (error) => {
        let errorMessage = 'An error occurred';
        if (error.response?.status === 406) {
            errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
        } else if (error.response?.status === 404) {
            errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 412) {
            errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
            errorMessage = error.response?.data?.error;
        }

        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
    };

    const handleEndDateChange = (date) => {

        const start = new Date(startDate);
        const end = new Date(date);

        // Remove time part
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const maxEndDate = new Date(start);
        maxEndDate.setDate(start.getDate() + MAX_DATE_RANGE_DAYS);

        if (maxEndDate && startDate && maxEndDate < startDate) {
            setError('End date cannot be earlier than start date');
        } else {
            setError('');
            setEndDate(date);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setClicked(true);
        setBtnLoading(true);

        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

        await getAddonsData(adjustedStartDate, adjustedEndDate, selectedOutlet.value, selectedCategory, addonGroup, selectedAddonValue);

        setBtnLoading(false);
    };

    const handlePrintReport = () => {
        // Calculate totals using sortedData so the print matches what the user sees
        const totalSalesCount = sortedData?.reduce((sum, addon) => sum + (addon.totalAddonSalesCount || 0), 0) || 0;
        const totalDiscount = sortedData?.reduce((sum, addon) => sum + (addon.totalDiscount || 0), 0) || 0;
        const totalTaxable = sortedData?.reduce((sum, addon) => sum + (addon.totalTaxable || 0), 0) || 0;
        const totalTaxAmount = sortedData?.reduce((sum, addon) => sum + (addon.totalTaxAmount || 0), 0) || 0;
        const totalGrandTotal = sortedData?.reduce((sum, addon) => sum + (addon.totalGrandTotal || 0), 0) || 0;

        // Create a new window for printing
        const printWindow = window.open('', '_blank');

        // HTML content for printing
        const printContent = `
            <html>
            <head>
                <title>Addon Sales Report</title>
                <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                .print-header { text-align: center; margin-bottom: 20px; }
                .print-title { font-size: 20px; font-weight: bold; margin-bottom: 10px; }
                .print-date { font-size: 14px; color: #666; margin-bottom: 20px; }
                .print-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                .print-table th { background-color: #f8f9fa; text-align: left; padding: 8px; border: 1px solid #dee2e6; }
                .print-table td { padding: 8px; border: 1px solid #dee2e6; }
                .text-center { text-align: center; }
                .text-end { text-align: right; }
                .text-primary { color: #0d6efd; }
                .fw-semibold { font-weight: 600; }
                .text-success { color: #198754; }
                .bg-light { background-color: #f8f9fa !important; }
                .print-footer { margin-top: 30px; font-size: 12px; color: #666; text-align: center; }
                @page { size: auto; margin: 10mm; }
                </style>
            </head>
            <body>
                <div class="print-header">
                <div class="print-title">Addon Sales Report</div>
                <div class="print-date">Generated on: ${new Date().toLocaleString()}</div>
                </div>
                
                <table class="print-table">
                <thead>
                    <tr>
                    <th width="30">#</th>
                    <th width="80">Outlet</th>
                    <th>Category & Product</th>
                    <th>Addon Group</th>
                    <th>Addon Values</th>
                    <th class="text-center">Sales Count</th>
                    <th class="text-center">Total Sales</th>
                    <th width="80" class="text-end">Discount</th>
                    <th width="80" class="text-end">Taxable</th>
                    <th width="80" class="text-end">Tax</th>
                    <th width="80" class="text-end">Grand Total</th>
                    </tr>
                </thead>
                <tbody>
                    ${sortedData?.length > 0 ?
                sortedData.map((addon, index) => `
                        <tr>
                            <td class="text-muted">${index + 1}</td>
                            <td>${addon?.outletName || '--'}</td>
                            <td>
                                <div class="text-dark">${addon?.productName || '--'}</div>
                                <div class="fw-semibold text-primary">${addon?.categoryName || '--'}</div>
                            </td>
                            <td>${addon?.addonTitle || '----'}</td>
                            <td>
                                ${addon?.values?.map(val => `<div>${val.selectedValue}</div>`).join('') || '--'}
                            </td>
                            <td class="text-center">
                                ${addon?.values?.map(val => `<div>${val.totalSaleCount}</div>`).join('') || '--'}
                            </td>
                            <td class="text-center text-success">${addon.totalAddonSalesCount || '0'}</td>
                            <td class="text-end">₹ ${(addon.totalDiscount || 0).toFixed(2)}</td>
                            <td class="text-end">₹ ${(addon.totalTaxable || 0).toFixed(2)}</td>
                            <td class="text-end">₹ ${(addon.totalTaxAmount || 0).toFixed(2)}</td>
                            <td class="text-end text-success">₹ ${(addon.totalGrandTotal || 0).toFixed(2)}</td>
                        </tr>
                    `).join('') + `
                    <tr class="bg-light fw-semibold">
                        <td colspan="6" class="text-end">Total:</td>
                        <td class="text-center text-success">${totalSalesCount}</td>
                        <td class="text-end">₹ ${totalDiscount.toFixed(2)}</td>
                        <td class="text-end">₹ ${totalTaxable.toFixed(2)}</td>
                        <td class="text-end">₹ ${totalTaxAmount.toFixed(2)}</td>
                        <td class="text-end text-success">₹ ${totalGrandTotal.toFixed(2)}</td>
                    </tr>
                    `
                : `
                    <tr>
                        <td colspan="11" class="text-center">No data available</td>
                    </tr>
                    `
            }
                </tbody>
                </table>
                
                <div class="print-footer">
                <div>Report generated by the System</div>
                </div>
                
                <script>
                // Print automatically when the window loads
                window.onload = function() {
                    setTimeout(function() {
                    window.print();
                    window.close();
                    }, 200);
                };
                </script>
            </body>
            </html>
        `;

        // Write the content to the new window
        printWindow.document.open();
        printWindow.document.write(printContent);
        printWindow.document.close();
    };

    const handleSearchProducts = () => {
        const trimmedSearchText = searchText.trim().toLowerCase();
        if (trimmedSearchText) {
            const filtered = productList?.filter(product =>
                product?.productName?.toLowerCase().includes(trimmedSearchText)
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(productList);
        }
    };

    const handleAddonValueChange = (e) => {
        console.log("Selected Value :", e?.value);
        setSelectedAddonValue(e);
    }

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));

        setStartDate(start);
        setEndDate(end);
        getCategoryList();
        getAddons();
    }, []);

    useEffect(() => {
        if (searchText === "" && clicked) {
            getAddonsData(startDate, endDate, selectedOutlet.value, selectedCategory);
        }
    }, [searchText]);

    useEffect(() => {
        if (addonGroup) {
            const selectedGroup = addons.find(addon => addon._id === addonGroup.value);
            if (selectedGroup && Array.isArray(selectedGroup.addonValues)) {
                const values = selectedGroup.addonValues.map(val => ({
                    value: val._id,
                    label: val.value,
                }));
                setFilteredAddonValues(values);
            } else {
                setFilteredAddonValues([]);
            }
        } else {
            // Clear value and options if group is cleared
            setFilteredAddonValues([]);
            setSelectedAddonValue(null);
        }
    }, [addonGroup, addons]);


    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                <div className="card shadow-sm border-0">
                    <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="mb-0 fw-bold d-inline-block">
                                <i className="bi bi-sliders me-2"></i>ADDON SALES REPORT
                            </h4>
                        </div>
                        <div>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => navigate('/reports/all-reports')}
                                className="me-3 d-flex align-items-center fw-semibold"
                                style={{ height: '38px' }}
                            >
                                <ArrowLeft className="me-1" /> Back to Reports
                            </Button>
                        </div>
                    </div>
                    <hr className='mt-0 mb-0' />

                    <div className="card-body">
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3">
                            <Form onSubmit={handleSubmit}>
                                <Row className="g-3">
                                    <Col md={3}>
                                        <Form.Group controlId="outletSelect">
                                            <OutletSelect
                                                value={selectedOutlet}
                                                onChange={(option) => setSelectedOutlet(option)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId="categorySelect">
                                            <Form.Label className="fw-semibold">
                                                <i className="bi bi-tags me-2"></i>Category
                                            </Form.Label>
                                            <Form.Select
                                                value={selectedCategory}
                                                onChange={(e) => {
                                                    setSelectedCategory(e.target.value)
                                                    setSelectedCategoryName(e.target.selectedOptions[0].label)
                                                }
                                                }
                                                className="border-secondary"
                                            >
                                                <option value="">All Categories</option>
                                                {categoryList?.map((category) => (
                                                    <option key={category?._id} value={category?._id} label={category?.name}>
                                                        {category?.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId="startDate">
                                            <Form.Label className="fw-semibold">
                                                <i className="bi bi-calendar me-2"></i>Start Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => {
                                                    setStartDate(date);
                                                    // Reset endDate if it exceeds 60 days from the new startDate
                                                    if (endDate && date && endDate > new Date(date.getTime() + MAX_DATE_RANGE_DAYS * 24 * 60 * 60 * 1000)) {
                                                        setEndDate(null);
                                                    }
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                className="form-control border-secondary"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId="endDate">
                                            <Form.Label className="fw-semibold">
                                                <i className="bi bi-calendar me-2"></i>End Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => {
                                                    if (startDate && date > new Date(startDate.getTime() + MAX_DATE_RANGE_DAYS * 24 * 60 * 60 * 1000)) {
                                                        setError(DATE_RANGE_ERROR_MESSAGE);
                                                    } else {
                                                        setError("");
                                                        handleEndDateChange(date);
                                                    }
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                minDate={startDate}
                                                maxDate={startDate ? new Date(startDate.getTime() + MAX_DATE_RANGE_DAYS * 24 * 60 * 60 * 1000) : null}
                                                className="form-control border-secondary"
                                            />
                                            {error && <div className="text-danger small mt-1">{error}</div>}
                                        </Form.Group>
                                    </Col>


                                    <Col md={2}>
                                        <Form.Label className="fw-light text-light">
                                            .
                                        </Form.Label>
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                            disabled={!startDate || !endDate || !selectedOutlet || !selectedCategory}
                                        >
                                            {btnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Generate Report"
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>

                        {/* Search and Actions Section */}
                        <div className="mb-4 p-3 bg-light rounded-3 pt-0">
                            <Row className="g-3 align-items-center">
                                <Col md="3">
                                    <Form.Label className="fw-semibold">
                                        <i className="bi bi-box me-2"></i>Addon Group
                                    </Form.Label>
                                    <Select
                                        options={addons?.map((addon) => ({
                                            value: addon?._id,
                                            label: addon?.title,
                                        }))}
                                        value={addonGroup}
                                        onChange={(selectedOption) => setAddonGroup(selectedOption)}
                                        classNamePrefix="react-select"
                                        isClearable
                                        placeholder="Select Addon Group"
                                    />
                                </Col>
                                <Col md="3">
                                    <Form.Label className="fw-semibold">
                                        <i className="bi bi-collection me-2"></i>Addon Values
                                    </Form.Label>
                                    <Select
                                        components={animatedComponents}
                                        options={filteredAddonValues}
                                        value={selectedAddonValue}
                                        onChange={handleAddonValueChange}
                                        classNamePrefix="select"
                                        placeholder="Select Addon Value"
                                        isClearable
                                    />
                                </Col>
                                <Col md="3" lg="4">
                                    <Form.Label className='text-white'>.</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search by product name"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            className="border-secondary"
                                        />
                                        <Button
                                            className='w-25'
                                            variant="outline-secondary"
                                            onClick={handleSearchProducts}
                                            disabled={!searchText.trim()}
                                        >
                                            <Search className='me-1' /> Search
                                        </Button>
                                    </InputGroup>
                                </Col>

                                <Col md={2}>
                                    <div className='d-flex' style={{ flexDirection: 'column' }}>
                                        <Form.Label className='text-white'>.</Form.Label>
                                        <DropdownButton
                                            variant="outline-success"
                                            className='fw-semibold'
                                            title={
                                                <>
                                                    <FileEarmarkSpreadsheet className="me-2" />
                                                    {downloadBtnLoading ? <Spinner size='sm' /> : 'Download Excel'}
                                                </>
                                            }
                                            disabled={!filteredData.length}
                                        >
                                            <Dropdown.Item
                                                onClick={() => handleDownloadExcel(false)}
                                                disabled={downloadBtnLoading}
                                            >
                                                <FileEarmarkSpreadsheet className="me-2 text-success" />
                                                Download without costing
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => handleDownloadExcel(true)}
                                                disabled={downloadBtnLoading}
                                            >
                                                <FileEarmarkSpreadsheet className="me-2 text-success" />
                                                Download with costing
                                            </Dropdown.Item>
                                        </DropdownButton>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        {/* Results Section */}
                        {!clicked ? (
                            <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                <div className="text-center">
                                    <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                    <h5 className="text-muted mt-3">
                                        Please select filters and generate report
                                    </h5>
                                </div>
                            </div>
                        ) : (
                            <div className="table-responsive border rounded-3">
                                <Table striped bordered hover className="mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th width="50">#</th>

                                            {/* ── Sortable columns ── */}
                                            <th
                                                width="100"
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('outletName')}
                                            >
                                                Outlet <SortIcon column="outletName" />
                                            </th>

                                            <th
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('productName')}
                                            >
                                                Category &amp; Product <SortIcon column="productName" />
                                            </th>

                                            <th
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('addonTitle')}
                                            >
                                                Addon Group <SortIcon column="addonTitle" />
                                            </th>

                                            {/* Not sortable — contains nested array values */}
                                            <th>Addon Values</th>
                                            <th className="text-center">Sales Count</th>

                                            <th
                                                className="text-center"
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('totalAddonSalesCount')}
                                            >
                                                Total Sales Count <SortIcon column="totalAddonSalesCount" />
                                            </th>

                                            <th
                                                width="120"
                                                className="text-end"
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('totalDiscount')}
                                            >
                                                Discount <SortIcon column="totalDiscount" />
                                            </th>

                                            <th
                                                width="120"
                                                className="text-end"
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('totalTaxable')}
                                            >
                                                Taxable <SortIcon column="totalTaxable" />
                                            </th>

                                            <th
                                                width="120"
                                                className="text-end"
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('totalTaxAmount')}
                                            >
                                                Tax <SortIcon column="totalTaxAmount" />
                                            </th>

                                            <th
                                                width="120"
                                                className="text-end"
                                                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                                onClick={() => handleSort('totalGrandTotal')}
                                            >
                                                Grand Total <SortIcon column="totalGrandTotal" />
                                            </th>
                                            {/* ──────────────────────── */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="11" className="text-center py-4">
                                                    <Spinner animation="border" variant="primary" />
                                                    <p className="mt-2 mb-0">Loading product data...</p>
                                                </td>
                                            </tr>
                                        ) : sortedData?.length > 0 ? (
                                            <>
                                                {sortedData.map((addon, index) => (
                                                    <tr key={index}>
                                                        <td className="text-muted">{index + 1}</td>
                                                        <td>{addon?.outletName}</td>
                                                        <td>
                                                            <div className="text-dark">{addon?.productName}</div>
                                                            <div className="fw-semibold text-primary">{addon?.categoryName}</div>
                                                        </td>
                                                        <td className='fw-semibold text-muted'>
                                                            {addon?.addonTitle ? `${addon?.addonTitle}` : '----'}
                                                        </td>
                                                        <td>
                                                            {addon?.values?.map((val, i) => (
                                                                <div key={i}>{val.selectedValue}</div>
                                                            ))}
                                                        </td>
                                                        <td className="text-center">
                                                            {addon?.values?.map((val, i) => (
                                                                <div key={i}>{val.totalSaleCount}</div>
                                                            ))}
                                                        </td>
                                                        <td className="text-center text-success fw-semibold">{addon.totalAddonSalesCount}</td>
                                                        <td className="text-end">₹ {addon.totalDiscount.toFixed(2)}</td>
                                                        <td className="text-end">₹ {addon.totalTaxable.toFixed(2)}</td>
                                                        <td className="text-end">₹ {addon.totalTaxAmount.toFixed(2)}</td>
                                                        <td className="text-end fw-bold text-success">₹ {addon.totalGrandTotal.toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                                {/* Total row — always sums all filteredData regardless of sort */}
                                                <tr className="fw-bold bg-light">
                                                    <td colSpan="6" className="text-end">Total:</td>
                                                    <td className="text-center text-success">
                                                        {filteredData.reduce((sum, addon) => sum + addon.totalAddonSalesCount, 0)}
                                                    </td>
                                                    <td className="text-end">₹ {filteredData.reduce((sum, addon) => sum + addon.totalDiscount, 0).toFixed(2)}</td>
                                                    <td className="text-end">₹ {filteredData.reduce((sum, addon) => sum + addon.totalTaxable, 0).toFixed(2)}</td>
                                                    <td className="text-end">₹ {filteredData.reduce((sum, addon) => sum + addon.totalTaxAmount, 0).toFixed(2)}</td>
                                                    <td className="text-end text-success">₹ {filteredData.reduce((sum, addon) => sum + addon.totalGrandTotal, 0).toFixed(2)}</td>
                                                </tr>
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan="11" className="text-center py-4">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </React.Fragment>
    )

}

export default AddonSalesReport



// New Addon Sales Report
// import React, { useState, useEffect, useMemo } from 'react';
// import Header from '../../layouts/Header';
// import {
//     Badge, Button, Col, Dropdown, DropdownButton,
//     Form, InputGroup, Nav, Row, Spinner, Table
// } from 'react-bootstrap';
// import { ArrowLeft, FileEarmarkSpreadsheet, Search } from 'react-bootstrap-icons';
// import DatePicker from 'react-datepicker';
// import axios from '../../api/axios';
// import { toast } from 'react-toastify';
// import Select from 'react-select';
// import makeAnimated from 'react-select/animated';
// import { useNavigate } from 'react-router-dom';
// import OutletSelect from '../../components/OutletSelect';
// import { MAX_DATE_RANGE_DAYS, DATE_RANGE_ERROR_MESSAGE } from '../../constants/dateConstants';

// /* ─────────────────────────────────────────────────────────────────────────────
//    Small reusable helpers
// ───────────────────────────────────────────────────────────────────────────── */
// const SortIcon = ({ sortConfig, column }) => {
//     if (sortConfig.key !== column)
//         return <span style={{ opacity: 0.3, marginLeft: 4, fontSize: 11 }}>⇅</span>;
//     return (
//         <span style={{ marginLeft: 4, fontSize: 11, color: '#0d6efd' }}>
//             {sortConfig.direction === 'asc' ? '↑' : '↓'}
//         </span>
//     );
// };

// const useSortedData = (data, sortConfig) =>
//     useMemo(() => {
//         if (!sortConfig.key) return data;
//         return [...data].sort((a, b) => {
//             const aVal = a[sortConfig.key] ?? 0;
//             const bVal = b[sortConfig.key] ?? 0;
//             const cmp = typeof aVal === 'string' ? aVal.localeCompare(bVal) : aVal - bVal;
//             return sortConfig.direction === 'asc' ? cmp : -cmp;
//         });
//     }, [data, sortConfig]);

// const SORTABLE_COLS = [
//     { key: 'outletName',           label: 'Outlet',              width: 110                          },
//     { key: 'productName',          label: 'Category & Product',  width: null                         },
//     { key: 'addonTitle',           label: 'Addon Group',         width: null                         },
//     { key: null,                   label: 'Addon Values',        width: null                         },
//     { key: null,                   label: 'Sales Count',         width: null,  center: true          },
//     { key: 'totalAddonSalesCount', label: 'Total Sales Count',   width: null,  center: true          },
//     { key: 'totalDiscount',        label: 'Discount',            width: 120,   end: true             },
//     { key: 'totalTaxable',         label: 'Taxable',             width: 120,   end: true             },
//     { key: 'totalTaxAmount',       label: 'Tax',                 width: 110,   end: true             },
//     { key: 'totalGrandTotal',      label: 'Grand Total',         width: 120,   end: true             },
// ];

// /* ─────────────────────────────────────────────────────────────────────────────
//    AddonTable — renders one table of addon rows + totals row
//    mode: 'cumulative' | 'outlet-wise'
//    In outlet-wise mode the Outlet column is hidden — the active tab already
//    tells the user which outlet they are looking at.
// ───────────────────────────────────────────────────────────────────────────── */
// const AddonTable = ({ rows, loading, mode = 'cumulative' }) => {
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

//     const isOutletWise = mode === 'outlet-wise';

//     // Filter out the Outlet column when in outlet-wise mode
//     const visibleCols = isOutletWise
//         ? SORTABLE_COLS.filter(col => col.key !== 'outletName')
//         : SORTABLE_COLS;

//     // colSpan for loading / empty rows accounts for # column + visible cols
//     const colSpan = 1 + visibleCols.length;

//     const handleSort = (key) => {
//         if (!key) return;
//         setSortConfig(prev => ({
//             key,
//             direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
//         }));
//     };

//     const sortedRows = useSortedData(rows, sortConfig);

//     const totals = useMemo(() => rows.reduce((acc, r) => ({
//         totalAddonSalesCount: acc.totalAddonSalesCount + (r.totalAddonSalesCount || 0),
//         totalDiscount:        acc.totalDiscount        + (r.totalDiscount        || 0),
//         totalTaxable:         acc.totalTaxable         + (r.totalTaxable         || 0),
//         totalTaxAmount:       acc.totalTaxAmount       + (r.totalTaxAmount       || 0),
//         totalGrandTotal:      acc.totalGrandTotal      + (r.totalGrandTotal      || 0),
//     }), { totalAddonSalesCount: 0, totalDiscount: 0, totalTaxable: 0, totalTaxAmount: 0, totalGrandTotal: 0 }), [rows]);

//     return (
//         <div className="table-responsive border rounded-3">
//             <Table striped bordered hover className="mb-0">
//                 <thead className="bg-light">
//                     <tr>
//                         <th width={50}>#</th>
//                         {visibleCols.map((col, i) => (
//                             <th
//                                 key={i}
//                                 width={col.width ?? undefined}
//                                 className={`${col.center ? 'text-center' : ''} ${col.end ? 'text-end' : ''}`}
//                                 style={col.key ? { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' } : {}}
//                                 onClick={() => handleSort(col.key)}
//                             >
//                                 {col.label}
//                                 {col.key && <SortIcon sortConfig={sortConfig} column={col.key} />}
//                             </th>
//                         ))}
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {loading ? (
//                         <tr>
//                             <td colSpan={colSpan} className="text-center py-4">
//                                 <Spinner animation="border" variant="primary" />
//                                 <p className="mt-2 mb-0">Loading data…</p>
//                             </td>
//                         </tr>
//                     ) : sortedRows.length > 0 ? (
//                         <>
//                             {sortedRows.map((addon, idx) => (
//                                 <tr key={`${addon._id}_${idx}`}>
//                                     <td className="text-muted">{idx + 1}</td>
//                                     {/* Outlet column — cumulative only */}
//                                     {!isOutletWise && (
//                                     <td>
//                                         {addon.outletNames && addon.outletNames.length > 1 ? (
//                                             <div className="d-flex flex-column gap-1">
//                                                 {addon.outletNames.map((name, ni) => (
//                                                     <Badge
//                                                         key={ni}
//                                                         bg="light"
//                                                         text="dark"
//                                                         className="border text-start fw-normal"
//                                                         style={{ fontSize: 11, whiteSpace: 'normal' }}
//                                                     >
//                                                         {name}
//                                                     </Badge>
//                                                 ))}
//                                             </div>
//                                         ) : (
//                                             addon.outletName
//                                         )}
//                                     </td>
//                                     )}
//                                     <td>
//                                         <div className="text-dark">{addon.productName}</div>
//                                         <div className="fw-semibold text-primary">{addon.categoryName}</div>
//                                     </td>
//                                     <td className="fw-semibold text-muted">{addon.addonTitle || '----'}</td>
//                                     <td>
//                                         {addon.values?.map((v, i) => <div key={i}>{v.selectedValue}</div>)}
//                                     </td>
//                                     <td className="text-center">
//                                         {addon.values?.map((v, i) => <div key={i}>{v.totalSaleCount}</div>)}
//                                     </td>
//                                     <td className="text-center text-success fw-semibold">{addon.totalAddonSalesCount}</td>
//                                     <td className="text-end">₹ {(addon.totalDiscount    || 0).toFixed(2)}</td>
//                                     <td className="text-end">₹ {(addon.totalTaxable     || 0).toFixed(2)}</td>
//                                     <td className="text-end">₹ {(addon.totalTaxAmount   || 0).toFixed(2)}</td>
//                                     <td className="text-end fw-bold text-success">₹ {(addon.totalGrandTotal || 0).toFixed(2)}</td>
//                                 </tr>
//                             ))}
//                             <tr className="fw-bold bg-light">
//                                 <td colSpan={isOutletWise ? 5 : 6} className="text-end">Total:</td>
//                                 <td className="text-center text-success">{totals.totalAddonSalesCount}</td>
//                                 <td className="text-end">₹ {totals.totalDiscount.toFixed(2)}</td>
//                                 <td className="text-end">₹ {totals.totalTaxable.toFixed(2)}</td>
//                                 <td className="text-end">₹ {totals.totalTaxAmount.toFixed(2)}</td>
//                                 <td className="text-end text-success">₹ {totals.totalGrandTotal.toFixed(2)}</td>
//                             </tr>
//                         </>
//                     ) : (
//                         <tr>
//                             <td colSpan={colSpan} className="text-center py-4">No data available</td>
//                         </tr>
//                     )}
//                 </tbody>
//             </Table>
//         </div>
//     );
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    Main component
// ───────────────────────────────────────────────────────────────────────────── */
// const AddonSalesReport = () => {
//     const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
//     const [skin, setSkin] = useState(currentSkin);
//     const animatedComponents = makeAnimated();
//     const navigate = useNavigate();

//     const accessToken = localStorage.getItem('authToken');

//     // ── Filter state ─────────────────────────────────────────────────────────
//     const [selectedOutlets, setSelectedOutlets]         = useState([]);
//     const [categoryList, setCategoryList]               = useState([]);
//     const [selectedCategories, setSelectedCategories]   = useState([]);
//     const [startDate, setStartDate]                     = useState(null);
//     const [endDate, setEndDate]                         = useState(null);
//     const [error, setError]                             = useState('');
//     const [addonGroup, setAddonGroup]                   = useState(null);
//     const [addons, setAddons]                           = useState([]);
//     const [filteredAddonValues, setFilteredAddonValues] = useState([]);
//     const [selectedAddonValue, setSelectedAddonValue]   = useState(null);

//     // ── Result state ─────────────────────────────────────────────────────────
//     const [rawData, setRawData]                   = useState([]);
//     const [clicked, setClicked]                   = useState(false);
//     const [loading, setLoading]                   = useState(false);
//     const [btnLoading, setBtnLoading]             = useState(false);
//     const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

//     // ── View mode: 'cumulative' | 'outlet-wise' ───────────────────────────────
//     const [viewMode, setViewMode]           = useState('cumulative');
//     const [activeOutletId, setActiveOutletId] = useState(null);

//     // ── Search ────────────────────────────────────────────────────────────────
//     const [searchText, setSearchText]       = useState('');
//     const [searchApplied, setSearchApplied] = useState('');

//     /* ── Derived data ─────────────────────────────────────────────────────── */
//     const cumulativeRows = useMemo(() => {
//         const map = new Map();

//         rawData.forEach(outlet => {
//             (outlet.addons ?? []).forEach(addon => {
//                 const key = [
//                     addon.productName?.trim().toLowerCase()  ?? '',
//                     addon.addonTitle?.trim().toLowerCase()   ?? '',
//                     addon.categoryName?.trim().toLowerCase() ?? '',
//                 ].join('||');

//                 if (!map.has(key)) {
//                     map.set(key, {
//                         _id:          addon._id,
//                         productName:  addon.productName?.trim()  ?? addon.productName,
//                         categoryName: addon.categoryName?.trim() ?? addon.categoryName,
//                         addonTitle:   addon.addonTitle?.trim()   ?? addon.addonTitle,
//                         outletIds:    new Set([outlet.outlet]),
//                         outletNames:  [outlet.outletName],
//                         valuesMap: Object.fromEntries(
//                             (addon.values ?? []).map(v => [v.selectedValue, v.totalSaleCount])
//                         ),
//                         totalAddonSalesCount: addon.totalAddonSalesCount || 0,
//                         totalDiscount:        addon.totalDiscount        || 0,
//                         totalTaxable:         addon.totalTaxable         || 0,
//                         totalTaxAmount:       addon.totalTaxAmount       || 0,
//                         totalGrandTotal:      addon.totalGrandTotal      || 0,
//                     });
//                 } else {
//                     const existing = map.get(key);

//                     if (!existing.outletIds.has(outlet.outlet)) {
//                         existing.outletIds.add(outlet.outlet);
//                         existing.outletNames.push(outlet.outletName);
//                     }

//                     (addon.values ?? []).forEach(v => {
//                         existing.valuesMap[v.selectedValue] =
//                             (existing.valuesMap[v.selectedValue] || 0) + v.totalSaleCount;
//                     });

//                     existing.totalAddonSalesCount += addon.totalAddonSalesCount || 0;
//                     existing.totalDiscount        += addon.totalDiscount        || 0;
//                     existing.totalTaxable         += addon.totalTaxable         || 0;
//                     existing.totalTaxAmount       += addon.totalTaxAmount       || 0;
//                     existing.totalGrandTotal      += addon.totalGrandTotal      || 0;
//                 }
//             });
//         });

//         return Array.from(map.values()).map(({ outletIds, valuesMap, ...row }) => ({
//             ...row,
//             outletName: row.outletNames.join(', '),
//             values: Object.entries(valuesMap).map(([selectedValue, totalSaleCount]) => ({
//                 selectedValue,
//                 totalSaleCount,
//             })),
//         }));
//     }, [rawData]);

//     const filteredCumulative = useMemo(() => {
//         if (!searchApplied) return cumulativeRows;
//         const q = searchApplied.toLowerCase();
//         return cumulativeRows.filter(r => r.productName?.toLowerCase().includes(q));
//     }, [cumulativeRows, searchApplied]);

//     // Outlet-wise: rows for the active outlet tab
//     const outletWiseRows = useMemo(() => {
//         if (!activeOutletId) return [];
//         const outlet = rawData.find(o => o.outlet === activeOutletId);
//         if (!outlet) return [];
        
//         const rows = (outlet.addons ?? []);
        
//         if (!searchApplied) return rows;
//         const q = searchApplied.toLowerCase();
//         return rows.filter(r => r.productName?.toLowerCase().includes(q));
//     }, [rawData, activeOutletId, searchApplied]);

//     /* ── API helpers ──────────────────────────────────────────────────────── */
//     const buildQueryParams = (start, end, isDownload = false, isCosting = false) => {
//         const s = start?.toISOString().split('T')[0];
//         const e = end?.toISOString().split('T')[0];
//         let qs = `startDate=${s}&endDate=${e}`;
//         if (addonGroup)        qs += `&addonId=${addonGroup.value}`;
//         if (selectedAddonValue) qs += `&addonValueId=${selectedAddonValue.value}`;
//         if (isCosting)         qs += `&isCosting=true`;
//         return qs;
//     };

//     const buildBody = () => ({
//         outletIds:   selectedOutlets.map(o => o.value),
//         categoryIds: selectedCategories.map(c => c.value),
//     });

//     const fetchReport = async (start, end) => {
//         try {
//             const headers  = { Authorization: `Bearer ${accessToken}` };
//             const qs       = buildQueryParams(start, end);
//             const response = await axios.post(
//                 `addons/addon-sales-report-for-outlet/new?${qs}`,
//                 buildBody(),
//                 { headers }
//             );
//             const data = response?.data?.data ?? [];
//             console.log('API Response Data:', data);

//             const frozen = JSON.parse(JSON.stringify(data));
//             setRawData(frozen);
            
//             // Set the first outlet as active when data is loaded
//             if (frozen.length > 0) {
//                 setActiveOutletId(frozen[0].outlet);
//                 console.log('Setting active outlet to:', frozen[0].outlet, frozen[0].outletName);
//             }
            
//             toast.success('Data Fetched Successfully', { position: 'top-right', autoClose: 3000, theme: 'light' });
//         } catch (err) {
//             setRawData([]);
//             handleApiError(err);
//         }
//     };

//     const handleDownloadExcel = async (isCosting) => {
//         setDownloadBtnLoading(true);
//         try {
//             const adjustedStart = new Date(startDate); adjustedStart.setHours(23, 59, 59, 999);
//             const adjustedEnd   = new Date(endDate);   adjustedEnd.setHours(23, 59, 59, 999);

//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//                 'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//             };
//             const qs       = buildQueryParams(adjustedStart, adjustedEnd, true, isCosting);
//             const response = await axios.post(
//                 `addons/addon-sales-report-for-outlet/new?${qs}`,
//                 buildBody(),
//                 { headers, responseType: 'blob' }
//             );

//             const blob = new Blob([response.data], {
//                 type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//             });
//             const link  = document.createElement('a');
//             link.href   = window.URL.createObjectURL(blob);
//             const s     = adjustedStart.toISOString().split('T')[0];
//             const e     = adjustedEnd.toISOString().split('T')[0];
//             link.download = `Addon Sales Report (${s} - ${e}).xlsx`;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(link.href);

//             toast.success('Excel downloaded successfully!', { position: 'top-right', autoClose: 3000, theme: 'light' });
//         } catch (err) {
//             handleApiError(err);
//         } finally {
//             setDownloadBtnLoading(false);
//         }
//     };

//     const handleApiError = (error) => {
//         const s   = error.response?.status;
//         let msg   = 'An error occurred';
//         if ([406, 404, 412].includes(s))
//             msg = error.response?.data?.error?.message || error.response?.data?.data?.message || msg;
//         else if (s === 500) msg = error.response?.data?.error || msg;
//         toast.error(msg, { position: 'top-right', autoClose: 3000, theme: 'light' });
//     };

//     /* ── Form handlers ────────────────────────────────────────────────────── */
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setClicked(true);
//         setBtnLoading(true);
//         setSearchText('');
//         setSearchApplied('');
//         const adjustedStart = new Date(startDate); adjustedStart.setHours(23, 59, 59, 999);
//         const adjustedEnd   = new Date(endDate);   adjustedEnd.setHours(23, 59, 59, 999);
//         await fetchReport(adjustedStart, adjustedEnd);
//         setBtnLoading(false);
//     };

//     const handleEndDateChange = (date) => {
//         const start  = new Date(startDate); start.setHours(0, 0, 0, 0);
//         const end    = new Date(date);      end.setHours(0, 0, 0, 0);
//         if (end < start) { setError('End date cannot be earlier than start date'); return; }
//         setError(''); setEndDate(date);
//     };

//     const handleSearchProducts = () => setSearchApplied(searchText.trim());

//     /* ── Handle outlet tab change ────────────────────────────────────────── */
//     const handleOutletTabChange = (outletId) => {
//         console.log('Tab changed to outlet:', outletId);
//         setActiveOutletId(outletId);
//     };

//     /* ── Init ─────────────────────────────────────────────────────────────── */
//     useEffect(() => {
//         const now   = new Date();
//         const first = new Date(now.getFullYear(), now.getMonth(), 1);
//         const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//         setStartDate(new Date(first.setHours(23, 59, 59, 999)));
//         setEndDate(new Date(today.setHours(23, 59, 59, 999)));
//         getCategoryList();
//         getAddons();
//     }, []);

//     const getAddons = async () => {
//         try {
//             const response = await axios.get('addons?page=1&limit=1000', {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//             });
//             setAddons(response?.data?.data?.addons ?? []);
//         } catch { /* silent */ }
//     };

//     const getCategoryList = async () => {
//         try {
//             const response = await axios.get('masters/category/get', {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//             });
//             if (response?.data?.status) setCategoryList(response?.data?.data?.categories ?? []);
//         } catch (err) { handleApiError(err); }
//     };

//     // Populate addon value options when group changes
//     useEffect(() => {
//         if (addonGroup) {
//             const grp = addons.find(a => a._id === addonGroup.value);
//             setFilteredAddonValues(
//                 (grp?.addonValues ?? []).map(v => ({ value: v._id, label: v.value }))
//             );
//         } else {
//             setFilteredAddonValues([]);
//             setSelectedAddonValue(null);
//         }
//     }, [addonGroup, addons]);

//     /* ── Print ────────────────────────────────────────────────────────────── */
//     const handlePrintReport = () => {
//         const rowsToPrint = viewMode === 'cumulative' ? filteredCumulative : outletWiseRows;
//         const totals      = rowsToPrint.reduce((acc, r) => ({
//             totalAddonSalesCount: acc.totalAddonSalesCount + (r.totalAddonSalesCount || 0),
//             totalDiscount:        acc.totalDiscount        + (r.totalDiscount        || 0),
//             totalTaxable:         acc.totalTaxable         + (r.totalTaxable         || 0),
//             totalTaxAmount:       acc.totalTaxAmount       + (r.totalTaxAmount       || 0),
//             totalGrandTotal:      acc.totalGrandTotal      + (r.totalGrandTotal      || 0),
//         }), { totalAddonSalesCount: 0, totalDiscount: 0, totalTaxable: 0, totalTaxAmount: 0, totalGrandTotal: 0 });

//         const printWindow = window.open('', '_blank');
//         const viewLabel   = viewMode === 'cumulative'
//             ? 'Cumulative (All Outlets)'
//             : rawData.find(o => o.outlet === activeOutletId)?.outletName ?? '';

//         printWindow.document.write(`
//             <html><head><title>Addon Sales Report</title>
//             <style>
//                 body{font-family:Arial,sans-serif;margin:20px}
//                 .header{text-align:center;margin-bottom:20px}
//                 table{width:100%;border-collapse:collapse}
//                 th{background:#f8f9fa;padding:8px;border:1px solid #dee2e6;text-align:left}
//                 td{padding:8px;border:1px solid #dee2e6}
//                 .r{text-align:right}.c{text-align:center}.g{color:#198754}.b{font-weight:700}
//                 @page{size:auto;margin:10mm}
//             </style></head><body>
//             <div class="header">
//                 <h2>Addon Sales Report — ${viewLabel}</h2>
//                 <p>Generated: ${new Date().toLocaleString()}</p>
//             </div>
//             <table><thead><tr>
//                 <th>#</th>${viewMode === 'cumulative' ? '<th>Outlet</th>' : ''}<th>Category &amp; Product</th><th>Addon Group</th>
//                 <th>Addon Values</th><th class="c">Sales Count</th><th class="c">Total Sales Count</th>
//                 <th class="r">Discount</th><th class="r">Taxable</th><th class="r">Tax</th><th class="r">Grand Total</th>
//             </tr></thead><tbody>
//             ${rowsToPrint.map((a, i) => `
//                 <tr>
//                     <td>${i + 1}</td>
//                     ${viewMode === 'cumulative' ? `
//                     <td>${
//                         a.outletNames && a.outletNames.length > 1
//                             ? a.outletNames.join('<br/>')
//                             : (a.outletName || '--')
//                     }</td>` : ''}
//                     <td>${a.productName || '--'}<br/><b>${a.categoryName || ''}</b></td>
//                     <td>${a.addonTitle || '----'}</td>
//                     <td>${(a.values ?? []).map(v => v.selectedValue).join('<br/>')}</td>
//                     <td class="c">${(a.values ?? []).map(v => v.totalSaleCount).join('<br/>')}</td>
//                     <td class="c g">${a.totalAddonSalesCount || 0}</td>
//                     <td class="r">₹ ${(a.totalDiscount    || 0).toFixed(2)}</td>
//                     <td class="r">₹ ${(a.totalTaxable     || 0).toFixed(2)}</td>
//                     <td class="r">₹ ${(a.totalTaxAmount   || 0).toFixed(2)}</td>
//                     <td class="r g b">₹ ${(a.totalGrandTotal || 0).toFixed(2)}</td>
//                 </tr>`).join('')}
//             <tr class="b">
//                 <td colspan="${viewMode === 'cumulative' ? 6 : 5}" class="r">Total:</td>
//                 <td class="c g">${totals.totalAddonSalesCount}</td>
//                 <td class="r">₹ ${totals.totalDiscount.toFixed(2)}</td>
//                 <td class="r">₹ ${totals.totalTaxable.toFixed(2)}</td>
//                 <td class="r">₹ ${totals.totalTaxAmount.toFixed(2)}</td>
//                 <td class="r g">₹ ${totals.totalGrandTotal.toFixed(2)}</td>
//             </tr>
//             </tbody></table>
//             <script>window.onload=function(){setTimeout(function(){window.print();window.close();},200)}<\/script>
//             </body></html>`);
//         printWindow.document.close();
//     };

//     /* ── Derived for submit button ────────────────────────────────────────── */
//     const canSubmit = startDate && endDate && selectedOutlets.length > 0 && !error;
//     const hasData   = rawData.length > 0;

//     /* ─────────────────────────────────────────────────────────────────────── */
//     return (
//         <React.Fragment>
//             <Header onSkin={setSkin} />
//             <div className={`main main-app p-3 p-lg-4 ${skin === 'dark' ? 'bg-dark text-light' : 'bg-light'}`}>
//                 <div className="card shadow-sm border-0">

//                     {/* ── Card Header ── */}
//                     <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
//                         <h4 className="mb-0 fw-bold">
//                             <i className="bi bi-sliders me-2"></i>ADDON SALES REPORT
//                         </h4>
//                         <Button
//                             variant="outline-secondary" size="sm"
//                             onClick={() => navigate('/reports/all-reports')}
//                             className="d-flex align-items-center fw-semibold"
//                             style={{ height: 38 }}
//                         >
//                             <ArrowLeft className="me-1" /> Back to Reports
//                         </Button>
//                     </div>
//                     <hr className="mt-0 mb-0" />

//                     <div className="card-body">

//                         {/* ── Filters ── */}
//                         <div className="p-3 bg-light rounded-3 mb-3">
//                             <Form onSubmit={handleSubmit}>
//                                 <Row className="g-3">

//                                     {/* Multi-select outlets */}
//                                     <Col md={3}>
//                                         <Form.Group>
//                                             <OutletSelect
//                                                 isMulti
//                                                 value={selectedOutlets}
//                                                 onChange={(opts) => setSelectedOutlets(opts ?? [])}
//                                             />
//                                         </Form.Group>
//                                     </Col>

//                                     {/* Multi-select categories */}
//                                     <Col md={3}>
//                                         <Form.Group>
//                                             <Form.Label className="fw-semibold">
//                                                 <i className="bi bi-tags me-2"></i>Category
//                                             </Form.Label>
//                                             <Select
//                                                 isMulti
//                                                 options={categoryList.map(c => ({ value: c._id, label: c.name }))}
//                                                 value={selectedCategories}
//                                                 onChange={(opts) => setSelectedCategories(opts ?? [])}
//                                                 classNamePrefix="react-select"
//                                                 isClearable
//                                                 placeholder="All Categories"
//                                             />
//                                         </Form.Group>
//                                     </Col>

//                                     {/* Start date */}
//                                     <Col md={2}>
//                                         <Form.Group>
//                                             <Form.Label className="fw-semibold">
//                                                 <i className="bi bi-calendar me-2"></i>Start Date
//                                             </Form.Label>
//                                             <DatePicker
//                                                 selected={startDate}
//                                                 onChange={(date) => {
//                                                     setStartDate(date);
//                                                     if (endDate && date && endDate > new Date(date.getTime() + MAX_DATE_RANGE_DAYS * 864e5))
//                                                         setEndDate(null);
//                                                 }}
//                                                 dateFormat="dd-MM-yyyy"
//                                                 className="form-control border-secondary"
//                                             />
//                                         </Form.Group>
//                                     </Col>

//                                     {/* End date */}
//                                     <Col md={2}>
//                                         <Form.Group>
//                                             <Form.Label className="fw-semibold">
//                                                 <i className="bi bi-calendar me-2"></i>End Date
//                                             </Form.Label>
//                                             <DatePicker
//                                                 selected={endDate}
//                                                 onChange={(date) => {
//                                                     if (startDate && date > new Date(startDate.getTime() + MAX_DATE_RANGE_DAYS * 864e5)) {
//                                                         setError(DATE_RANGE_ERROR_MESSAGE);
//                                                     } else {
//                                                         setError('');
//                                                         handleEndDateChange(date);
//                                                     }
//                                                 }}
//                                                 dateFormat="dd-MM-yyyy"
//                                                 minDate={startDate}
//                                                 maxDate={startDate ? new Date(startDate.getTime() + MAX_DATE_RANGE_DAYS * 864e5) : null}
//                                                 className="form-control border-secondary"
//                                             />
//                                             {error && <div className="text-danger small mt-1">{error}</div>}
//                                         </Form.Group>
//                                     </Col>

//                                     {/* Submit */}
//                                     <Col md={2}>
//                                         <Form.Label className="text-white">.</Form.Label>
//                                         <Button variant="primary" type="submit" className="w-100" disabled={!canSubmit}>
//                                             {btnLoading ? <Spinner size="sm" animation="border" /> : 'Generate Report'}
//                                         </Button>
//                                     </Col>
//                                 </Row>
//                             </Form>
//                         </div>

//                         {/* ── Addon filters + Search + Download ── */}
//                         <div className="mb-3 p-3 bg-light rounded-3 pt-0">
//                             <Row className="g-3 align-items-end">
//                                 <Col md={3}>
//                                     <Form.Label className="fw-semibold">
//                                         <i className="bi bi-box me-2"></i>Addon Group
//                                     </Form.Label>
//                                     <Select
//                                         options={addons.map(a => ({ value: a._id, label: a.title }))}
//                                         value={addonGroup}
//                                         onChange={setAddonGroup}
//                                         classNamePrefix="react-select"
//                                         isClearable
//                                         placeholder="Select Addon Group"
//                                     />
//                                 </Col>
//                                 <Col md={3}>
//                                     <Form.Label className="fw-semibold">
//                                         <i className="bi bi-collection me-2"></i>Addon Values
//                                     </Form.Label>
//                                     <Select
//                                         components={animatedComponents}
//                                         options={filteredAddonValues}
//                                         value={selectedAddonValue}
//                                         onChange={setSelectedAddonValue}
//                                         classNamePrefix="select"
//                                         placeholder="Select Addon Value"
//                                         isClearable
//                                     />
//                                 </Col>
//                                 <Col md={3}>
//                                     <Form.Label className="fw-semibold">Search</Form.Label>
//                                     <InputGroup>
//                                         <Form.Control
//                                             type="text"
//                                             placeholder="Search by product name"
//                                             value={searchText}
//                                             onChange={e => setSearchText(e.target.value)}
//                                             onKeyDown={e => e.key === 'Enter' && handleSearchProducts()}
//                                             className="border-secondary"
//                                         />
//                                         <Button
//                                             variant="outline-secondary"
//                                             onClick={handleSearchProducts}
//                                             disabled={!searchText.trim()}
//                                             style={{ zIndex: 0 }}
//                                         >
//                                             <Search className="me-1" /> Search
//                                         </Button>
//                                     </InputGroup>
//                                 </Col>

//                                 <Col md={3} className="d-flex gap-2 justify-content-end">
//                                     <DropdownButton
//                                         variant="outline-success"
//                                         className="fw-semibold"
//                                         title={
//                                             <>
//                                                 <FileEarmarkSpreadsheet className="me-2" />
//                                                 {downloadBtnLoading ? <Spinner size="sm" /> : 'Download Excel'}
//                                             </>
//                                         }
//                                         disabled={!hasData || downloadBtnLoading}
//                                     >
//                                         <Dropdown.Item onClick={() => handleDownloadExcel(false)}>
//                                             <FileEarmarkSpreadsheet className="me-2 text-success" />
//                                             Without Costing
//                                         </Dropdown.Item>
//                                         <Dropdown.Item onClick={() => handleDownloadExcel(true)}>
//                                             <FileEarmarkSpreadsheet className="me-2 text-success" />
//                                             With Costing
//                                         </Dropdown.Item>
//                                     </DropdownButton>

//                                     <Button
//                                         variant="outline-secondary"
//                                         onClick={handlePrintReport}
//                                         disabled={!hasData}
//                                         title="Print current view"
//                                     >
//                                         <i className="bi bi-printer me-1"></i> Print
//                                     </Button>
//                                 </Col>
//                             </Row>
//                         </div>

//                         {/* ── Results ── */}
//                         {!clicked ? (
//                             <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
//                                 <div className="text-center">
//                                     <i className="bi bi-clipboard-data fs-1 text-muted"></i>
//                                     <h5 className="text-muted mt-3">Please select filters and generate report</h5>
//                                 </div>
//                             </div>
//                         ) : (
//                             <>
//                                 {/* ── View mode toggle + outlet summary badges ── */}
//                                 <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
//                                     <div className="btn-group" role="group">
//                                         <button
//                                             type="button"
//                                             className={`btn btn-sm ${viewMode === 'cumulative' ? 'btn-primary' : 'btn-outline-primary'}`}
//                                             onClick={() => setViewMode('cumulative')}
//                                         >
//                                             <i className="bi bi-bar-chart-line me-1"></i> Cumulative
//                                         </button>
//                                         <button
//                                             type="button"
//                                             className={`btn btn-sm ${viewMode === 'outlet-wise' ? 'btn-primary' : 'btn-outline-primary'}`}
//                                             onClick={() => setViewMode('outlet-wise')}
//                                             disabled={rawData.length === 0}
//                                         >
//                                             <i className="bi bi-diagram-3 me-1"></i> Outlet-wise
//                                         </button>
//                                     </div>

//                                     {/* Outlet summary badges — click to drill into outlet-wise */}
//                                     {viewMode === 'cumulative' && rawData.length > 0 && (
//                                         <div className="d-flex flex-wrap gap-2">
//                                             {rawData.map(o => (
//                                                 <Badge
//                                                     key={o.outlet}
//                                                     bg="light"
//                                                     text="dark"
//                                                     className="border px-2 py-1"
//                                                     style={{ fontSize: 12, cursor: 'pointer' }}
//                                                     title={`Click to view ${o.outletName} details`}
//                                                     onClick={() => {
//                                                         console.log('Badge clicked for outlet:', o.outlet, o.outletName);
//                                                         setActiveOutletId(o.outlet);
//                                                         setViewMode('outlet-wise');
//                                                     }}
//                                                 >
//                                                     <span className="text-primary fw-semibold">{o.outletName}</span>
//                                                     <span className="ms-2 text-success">₹ {(o.totalGrandTotal || 0).toFixed(2)}</span>
//                                                     <span className="ms-1 text-muted" style={{ fontSize: 10 }}>↗</span>
//                                                 </Badge>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* ── Outlet-wise tabs ── */}
//                                 {viewMode === 'outlet-wise' && rawData.length > 0 && (
//                                     <Nav 
//                                         variant="tabs" 
//                                         className="mb-3" 
//                                         activeKey={activeOutletId} 
//                                         onSelect={handleOutletTabChange}
//                                     >
//                                         {rawData.map(o => (
//                                             <Nav.Item key={o.outlet}>
//                                                 <Nav.Link eventKey={o.outlet}>
//                                                     {o.outletName}
//                                                     <Badge bg="success" className="ms-2" style={{ fontSize: 11 }}>
//                                                         ₹ {(o.totalGrandTotal || 0).toFixed(0)}
//                                                     </Badge>
//                                                 </Nav.Link>
//                                             </Nav.Item>
//                                         ))}
//                                     </Nav>
//                                 )}

//                                 {/* ── Summary cards (outlet-wise) ── */}
//                                 {viewMode === 'outlet-wise' && activeOutletId && (() => {
//                                     const o = rawData.find(x => x.outlet === activeOutletId);
//                                     if (!o) return null;
//                                     return (
//                                         <Row className="g-2 mb-3">
//                                             {[
//                                                 { label: 'Total Sales Count', val: o.totalAddonSalesCount,                     icon: 'bi-bag-check'  },
//                                                 { label: 'Discount',          val: `₹ ${(o.totalDiscount  || 0).toFixed(2)}`,  icon: 'bi-tag'        },
//                                                 { label: 'Taxable',           val: `₹ ${(o.totalTaxable   || 0).toFixed(2)}`,  icon: 'bi-receipt'    },
//                                                 { label: 'Tax',               val: `₹ ${(o.totalTaxAmount || 0).toFixed(2)}`,  icon: 'bi-percent'    },
//                                                 { label: 'Grand Total',       val: `₹ ${(o.totalGrandTotal|| 0).toFixed(2)}`,  icon: 'bi-cash-stack', highlight: true },
//                                             ].map((card, i) => (
//                                                 <Col key={i} xs={6} md>
//                                                     <div className={`border rounded-3 p-2 text-center ${card.highlight ? 'bg-success bg-opacity-10 border-success' : 'bg-white'}`}>
//                                                         <i className={`bi ${card.icon} fs-5 ${card.highlight ? 'text-success' : 'text-muted'}`}></i>
//                                                         <div className="small text-muted mt-1">{card.label}</div>
//                                                         <div className={`fw-bold ${card.highlight ? 'text-success' : ''}`}>{card.val}</div>
//                                                     </div>
//                                                 </Col>
//                                             ))}
//                                         </Row>
//                                     );
//                                 })()}

//                                 {/* ── Summary cards (cumulative) ── */}
//                                 {viewMode === 'cumulative' && rawData.length > 0 && (() => {
//                                     const totals = rawData.reduce((acc, o) => ({
//                                         totalAddonSalesCount: acc.totalAddonSalesCount + (o.totalAddonSalesCount || 0),
//                                         totalDiscount:        acc.totalDiscount        + (o.totalDiscount        || 0),
//                                         totalTaxable:         acc.totalTaxable         + (o.totalTaxable         || 0),
//                                         totalTaxAmount:       acc.totalTaxAmount       + (o.totalTaxAmount       || 0),
//                                         totalGrandTotal:      acc.totalGrandTotal      + (o.totalGrandTotal      || 0),
//                                     }), { totalAddonSalesCount: 0, totalDiscount: 0, totalTaxable: 0, totalTaxAmount: 0, totalGrandTotal: 0 });
//                                     return (
//                                         <Row className="g-2 mb-3">
//                                             {[
//                                                 { label: 'Total Sales Count', val: totals.totalAddonSalesCount,                      icon: 'bi-bag-check'  },
//                                                 { label: 'Discount',          val: `₹ ${totals.totalDiscount.toFixed(2)}`,            icon: 'bi-tag'        },
//                                                 { label: 'Taxable',           val: `₹ ${totals.totalTaxable.toFixed(2)}`,             icon: 'bi-receipt'    },
//                                                 { label: 'Tax',               val: `₹ ${totals.totalTaxAmount.toFixed(2)}`,           icon: 'bi-percent'    },
//                                                 { label: 'Grand Total',       val: `₹ ${totals.totalGrandTotal.toFixed(2)}`,          icon: 'bi-cash-stack', highlight: true },
//                                             ].map((card, i) => (
//                                                 <Col key={i} xs={6} md>
//                                                     <div className={`border rounded-3 p-2 text-center ${card.highlight ? 'bg-success bg-opacity-10 border-success' : 'bg-white'}`}>
//                                                         <i className={`bi ${card.icon} fs-5 ${card.highlight ? 'text-success' : 'text-muted'}`}></i>
//                                                         <div className="small text-muted mt-1">{card.label}</div>
//                                                         <div className={`fw-bold ${card.highlight ? 'text-success' : ''}`}>{card.val}</div>
//                                                     </div>
//                                                 </Col>
//                                             ))}
//                                         </Row>
//                                     );
//                                 })()}

//                                 {/* ── The actual table ── */}
//                                 <AddonTable
//                                     rows={viewMode === 'cumulative' ? filteredCumulative : outletWiseRows}
//                                     loading={loading}
//                                     mode={viewMode}
//                                 />
//                             </>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </React.Fragment>
//     );
// };

// export default AddonSalesReport;